import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import React from 'react';

type Props = NativeStackScreenProps<any, any>;
const Webview: React.FC<Props> = () => {
  return <Box />;
};
export default React.memo(Webview);
